var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('img',{staticClass:"main-img",attrs:{"src":_vm.imagePath,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }